// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--2YSbh","mintitle":"style-module--mintitle--1kNtg"};